export default function formatterNumber(
  value: number,
  options?: Intl.NumberFormatOptions,
) {
  return new Intl.NumberFormat('pt-BR', {
    ...options,
  }).format(value);
}
